import swal from "sweetalert";
import axiosInstance from "../api";
import { setGetReferralData, setGetSingleCategory } from "../reusable/reusableSlice";


export const getSingleCategoryId = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`user/getby_category_id/${id}`);
    if (response?.data) {
      dispatch(setGetSingleCategory(response?.data?.response))
    } else {
      dispatch(setGetSingleCategory([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setGetSingleCategory([]))
  }
};

export const addNewCategories = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("user/add_kyc_category", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/categories")
      // return response;
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const updateOneCategories = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("user/update_kyc_category", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/categories")
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};





export const deleteOneCategory = (id) => async (dispatch) => {
  // setLoading(true);
  try {
    const response = await axiosInstance.delete(`user/delete_kyc_category/${id}`);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      window.location.reload()
      // navigate("/membership")
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    // setLoading(false);
  }
};

export const getReferralListData = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`user/user_referral_list`, data);
    if (response?.data) {
      dispatch(setGetReferralData(response?.data?.response))
    } else {
      dispatch(setGetReferralData([]))
    }
  } catch (err) {
    dispatch(setGetReferralData([]))
  }
};